import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  IconButton,
  Button,
  Grid,
  Tooltip,
  Menu,
  MenuItem,
  CircularProgress, // ← Added for black spinner
} from '@mui/material';

import {
  FavoriteBorder,
  Favorite,
  PeopleAlt,
  Share,
  ThumbUpAltOutlined,
  ThumbUpAlt,
  Call,
  LocationOn,
  ChevronLeft,
  ChevronRight,
  MoreVert,
} from '@mui/icons-material';
import axios from 'axios';
import buildingImage from './../../../../Images/house.jpeg';
import CustomSearchBar from './../../Lease Module/CustomSearch';
import BottomNavbar from './../../Post Module/FormsBottomNavbar';
import { AuthContext } from './../../../AuthContext/AuthContext';
import { BASE_URL } from './../../../Api/ApiUrls';
import { useLocation } from 'react-router-dom';
import { Visibility as VisibilityIcon } from '@mui/icons-material';

const PropertyCard = () => { 
  const navigate = useNavigate();
  const locationn = useLocation();
  const { userId, logout } = useContext(AuthContext);
  const [searchQuery, setSearchQuery] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [daysLeft, setDaysLeft] = useState(null);
  const [error, setError] = useState(null);
  // const passedType = locationn.state?.type?.toLowerCase();
  const [menuPropertyId, setMenuPropertyId] = useState(null);
  const [saved, setSaved] = useState(() => {
    const stored = localStorage.getItem('savedBuy');
    return stored ? JSON.parse(stored) : [];
  });
  const [likedCards, setLikedCards] = useState({});
  const [properties, setProperties] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState({});
  const [showNoResults, setShowNoResults] = useState(false); // NEW: Control when to show "No properties found"



  const handleShare = (event, property) => {
    event.stopPropagation();
    alert(`Share clicked for: ${property.title}`);
  };

  const handleMenuOpen = (event, propertyId) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setMenuPropertyId(propertyId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuPropertyId(null);
  };

  const handleEdit = () => {
    navigate(`/user-edit-buy/${menuPropertyId}`);
  };

  const handleDelete = async () => {
    const confirmDelete = window.confirm(`Are you sure you want to delete property ID ${menuPropertyId}?`);

    if (!confirmDelete) {
      // User clicked "No"
      // handleMenuClose();
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/property/${menuPropertyId}/`, {
        method: 'DELETE',
      });

      if (response.ok) {
        alert(`Property ID ${menuPropertyId} deleted successfully.`);
        // FIX: Remove from state immediately
        setProperties(prev => prev.filter(p => p.id != menuPropertyId));
        // Optionally refresh your data or remove the item from the UI
      } else {
        const errorData = await response.json();
        alert(`Failed to delete property ID ${menuPropertyId}. Reason: ${errorData.detail || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error deleting property:', error);
      alert('An error occurred while trying to delete the property.');
    } finally {
      handleMenuClose();
    }
  };

  const handleDeleteProperty = async (propertyId) => {
  try {
    const confirmDelete = window.confirm(`Are you sure you want to delete property ID ${propertyId}?`);
    
    if (!confirmDelete) {
      return;
    }

    const response = await fetch(`${BASE_URL}/property/${propertyId}/`, {
      method: 'DELETE',
    });

    if (response.ok) {
      alert(`Property ID ${propertyId} deleted successfully.`);
      // FIX: Remove from state immediately
      setProperties(prev => prev.filter(p => p.id != propertyId));
    } else {
      const errorData = await response.json();
      alert(`Failed to delete property ID ${propertyId}. Reason: ${errorData.detail || 'Unknown error'}`);
    }
  } catch (error) {
    console.error('Error deleting property:', error);
    alert('An error occurred while trying to delete the property.');
  }
};

const isBudgetInRange = (propertyPrice, minBudget, maxBudget) => {
  if (!propertyPrice) return false;

  if (minBudget && maxBudget) {
    const range = (maxBudget - minBudget) * 0.10; 
    const extendedMin = Math.max(0, minBudget - range);
    const extendedMax = maxBudget + range;
    
    return propertyPrice >= extendedMin && propertyPrice <= extendedMax;
  }
  
  // If only min budget is provided
  if (minBudget && !maxBudget) {
    const extendedMin = minBudget * 0.90; // 10% below min budget
    return propertyPrice >= extendedMin;
  }
  
  // If only max budget is provided
  if (!minBudget && maxBudget) {
    const extendedMax = maxBudget * 1.10; // 10% above max budget
    return propertyPrice <= extendedMax;
  }
  
  return false;
};



  const fetchData = async () => {
    try {
      setLoading(true);
      setShowNoResults(false); // NEW: Hide "No properties found" while loading
      // Fetch categories first
      const categoriesResponse = await axios.get(`${BASE_URL}/property-category/`);
      setCategories(categoriesResponse.data);

      // Fetch properties
      const propertiesResponse = await axios.get(`${BASE_URL}/property/`);

      // Fetch cart items
      const cartResponse = await axios.get(`${BASE_URL}/user-cart/`);
      const cartItems = cartResponse.data;

      // Fetch buyer enquiries
      const enquiriesResponse = await axios.get(`${BASE_URL}/Enquiry/`);
      const enquiries = enquiriesResponse.data;

      // Fetch activities to get view counts
      const activitiesResponse = await axios.get(`${BASE_URL}/activities/`);
      const activities = activitiesResponse.data;

      const filtered = propertiesResponse.data
        .filter(item =>
          item.user_id == userId &&
          item.type.toLowerCase() == "sell" &&
          item.created_at
        )
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      const parsed = filtered.map(item => {
        // Wishlist count calculation
        const wishlistCount = cartItems.filter(
          cartItem => cartItem.property_id === item.property_id
        ).length;
        
        // View count calculation - count "Description" activities for this property
        const viewCount = activities.filter(activity => 
          activity.property_id === item.property_id && 
          activity.activity_type === "Description"
        ).length;

        // Matching buyers calculation with 10% range logic
        const matchingBuyersCount = enquiries.filter(enquiry => {
          // Get the property category
          const propertyCategory = categoriesResponse.data.find(
            cat => cat.category_id == item.category_id
          )?.category;

          // 1. Property Type Match (compare enquiry.property_type with property category)
          const typeMatch = enquiry.property_type && propertyCategory &&
            enquiry.property_type.toLowerCase() === propertyCategory.toLowerCase();

          // 2. Budget Match with 10% range flexibility
          const budgetMatch = isBudgetInRange(item.price, enquiry.min_budget, enquiry.max_budget);

          // 3. Location Match (check if within reasonable distance using lat/long)
          const locationMatch = () => {
            if (!enquiry.lat || !enquiry.long || !item.lat || !item.long) return false;

            // Convert strings to numbers
            const propLat = parseFloat(item.lat);
            const propLong = parseFloat(item.long);
            const enqLat = parseFloat(enquiry.lat);
            const enqLong = parseFloat(enquiry.long);

            // Calculate distance in kilometers using Haversine formula
            const R = 6371; // Earth's radius in km
            const dLat = (enqLat - propLat) * Math.PI / 180;
            const dLon = (enqLong - propLong) * Math.PI / 180;
            const a =
              Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(propLat * Math.PI / 180) * Math.cos(enqLat * Math.PI / 180) *
              Math.sin(dLon / 2) * Math.sin(dLon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            const distance = R * c;

            // Consider it a match if within 10km radius (adjust as needed)
            return distance <= 10;
          };

          // Count as match if all three criteria are met
          return typeMatch && budgetMatch && locationMatch();
        }).length;

        // Rest of your parsing logic...
        const parseCoord = (coord) => {
          if (!coord) return null;
          const cleaned = coord.replace(/"/g, '').replace(':', '.');
          return parseFloat(cleaned);
        };

        const matchedCategory = categoriesResponse.data.find(
          cat => cat.category_id == item.category_id
        );

        const categoryName = matchedCategory ? matchedCategory.category : 'Property';

        const images = item.property_images?.length > 0
          ? item.property_images.map(img => `${BASE_URL}${img.image}`)
          : [buildingImage];

        return {
          id: item.property_id,
          title: categoryName,
          location: item.location || 'Not specified',
          price: item.price, // Keep as number for matching
          formattedPrice: `₹${item.price?.toLocaleString()}`,
          date: item.created_at?.split('T')[0],
          facing: item.facing?.replace(/"/g, '') || 'N/A',
          area: item.site_area ? `${item.site_area} sq ft` : 'N/A',
          dimensions: item.roadwidth ? `${item.roadwidth} ft road` : 'N/A',
          posted_by: item.posted_by?.replace(/"/g, '') || 'Agent',
          lat: parseCoord(item.lat),
          long: parseCoord(item.long),
          length: item.length,
          width: item.width,
          mobile_no: item.mobile_no,
          property_name: item.property_name,
          images: images,
          propertyData: item,
          wishlistCount: wishlistCount,
          viewCount: viewCount, // Add view count
          matchingBuyersCount: matchingBuyersCount
        };
      });

      setProperties(parsed);
      // Initialize current image index for each property
      const initialIndexes = {};
      parsed.forEach(property => {
        initialIndexes[property.id] = 0;
      });
      setCurrentImageIndex(initialIndexes);
      
      // NEW: Only show "No properties found" after loading is complete and there are truly no properties
      if (parsed.length === 0) {
        setShowNoResults(true);
      }
    } catch (error) {
      console.error('Error fetching data:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
  fetchData();
}, [userId]);

  const handleWishlistClick = (propertyId, e) => {
    e.stopPropagation();
    console.log("Navigating to wishlist details for property:", propertyId);
    navigate(`/wishlist-users/${propertyId}`); // or whatever route you want
  };

  const handleMatchingBuyersClick = (propertyId, e) => {
    e.stopPropagation();
    console.log("Navigating to matching buyers for property:", propertyId);
    navigate(`/matching-buyers/${propertyId}`);
  };

  const handleNextImage = (propertyId, e) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => {
      const currentIndex = prev[propertyId];
      const property = properties.find(p => p.id == propertyId);
      const nextIndex = (currentIndex + 1) % property.images.length;
      return {
        ...prev,
        [propertyId]: nextIndex
      };
    });
  };

  const handlePrevImage = (propertyId, e) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => {
      const currentIndex = prev[propertyId];
      const property = properties.find(p => p.id == propertyId);
      const prevIndex = (currentIndex - 1 + property.images.length) % property.images.length;
      return {
        ...prev,
        [propertyId]: prevIndex
      };
    });
  };

  const openGoogleMapsWithDirections = (destLat, destLng) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const currentLat = position.coords.latitude
          const currentLng = position.coords.longitude;

          const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${currentLat},${currentLng}&destination=${destLat},${destLng}&travelmode=driving`;

          window.open(googleMapsUrl, '_blank');
        },
        (error) => {
          console.error("Error getting location:", error);
          alert("Could not get your location. Please allow location access.");
        }
      );
    } else {
      alert("Geolocation is not supported by your browser.");
    }
  };



  const filteredProperties = properties.filter((property) =>
    property.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    property.location.toLowerCase().includes(searchQuery.toLowerCase())
  );
  useEffect(() => {
    const calculateDaysLeft = (expiredDate) => {
      const now = new Date();
      const expiry = new Date(expiredDate);
      const diffTime = expiry - now;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays > 0 ? diffDays : 0;
    };

    const fetchUserPlan = async () => {
      setLoading(true);
      setError(null);

      try {
        if (!userId) {
          throw new Error('User ID is required');
        }

        const response = await fetch(`https://landnest.net:81/Get-all-plan/${userId}/`);

        if (!response.ok) {
          throw new Error(`Failed to fetch user plan: ${response.status}`);
        }

        const data = await response.json();

        // Check if data is an array and not empty
        if (!Array.isArray(data) || data.length === 0) {
          setDaysLeft(0);
          setLoading(false);
          return;
        }

        // Find active tenant subscription
        const matchedSub = data.find(
          (sub) => sub.status === true && sub.user_type === "Buyer"
        );

        if (!matchedSub) {
          setDaysLeft(0);
          setLoading(false);
          return;
        }

        if (matchedSub.expired_date) {
          const daysRemaining = calculateDaysLeft(matchedSub.expired_date);
          setDaysLeft(daysRemaining > 0 ? daysRemaining : 0);
        } else {
          setDaysLeft(0);
        }

      } catch (err) {
        console.error('Error fetching user plan:', err);
        setError(err.message || 'Failed to fetch subscription data');
        setDaysLeft(0); // Fallback to 0 days left on error
      } finally {
        setLoading(false);
      }
    };
    if (userId) {
      fetchUserPlan();
    }
  }, [userId]);

  const handleBoostProperty = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/boost-property/`, { user_id: userId });
      console.log('Boost success:', response.data);
      alert('Property boosted successfully!');
      // You can show a toast/snackbar here
    } catch (error) {
      console.error('Boost failed:', error);
      // You can show an error toast/snackbar here
    }
  };

  const handleExtensionClick = () => {
    navigate('/user-subscription');
  };

  // ==================== BLACK SPINNER WHILE LOADING ====================
  if (loading) {
    return (
      <Box
        sx={{
          backgroundColor: 'rgb(239, 231, 221)',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 3,
        }}
      >
        <CircularProgress size={40} thickness={5} sx={{ color: '#000000' }} />
        <Typography variant="h7" sx={{ color: '#000000', fontWeight: 600 }}>
          Loading properties...
        </Typography>
      </Box>
    );
  }

  if (error) return <Box>Error: {error}</Box>;

  const handleViewListClick = (propertyId, e) => {
  e.stopPropagation();
  console.log("Navigating to view list for property:", propertyId);
  navigate(`/viewlistpage/${propertyId}`);
};

  return (
    <Box sx={{ backgroundColor: 'rgb(239, 231, 221)', minHeight: '120vh' }}>
      {/* Sticky Search Bar */}
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          px: 1,
          py: 1,
          backgroundColor: 'rgb(239, 231, 221)',
        }}
      >
        <CustomSearchBar value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
      </Box>

      {/* Property List */}
      <Box sx={{ pb: 8 }}>
        <Box sx={{ pb: 2, px: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography
            variant="h6"
            sx={{
              color: 'text.primary',
              fontWeight: 'bold',
            }}
          >
            My Properties
          </Typography>

          <Button
            variant="contained"
            color="primary"
            onClick={handleBoostProperty}
            sx={{ fontSize: '0.8rem' }}
          >
            Boost Your Property
          </Button>
        </Box>
        {filteredProperties.length > 0 ? (
          filteredProperties.map((property) => (
            <Card
              key={property.id}
              sx={{
                mb: 1.2,
                mx: 2,
                borderRadius: 3,
                boxShadow: 2,
                transition: 'transform 0.2s ease-in-out',
                '&:hover': { transform: 'scale(1.015)', boxShadow: 4 },
              }}
              onClick={(e) => {
                // Check if click is on menu or menu button or any button
                const isInteractiveElement =
                  e.target.closest('button') ||
                  e.target.closest('svg') ||
                  e.target.closest('.MuiMenu-root') ||
                  e.target.closest('.MuiMenuItem-root');

                if (!isInteractiveElement) {
                  navigate('/buy-description', { state: { propertyId: property.id, property: property.propertyData } });
                }
              }}
            >
              <Box position="relative">
                <CardMedia
                  component="img"
                  image={property.images[currentImageIndex[property.id]]}
                  alt="Property"
                  sx={{
                    width: '100%',
                    height: '140px',
                    objectFit: 'cover',
                    borderTopLeftRadius: 12,
                    borderTopRightRadius: 12,
                  }}
                />

                {/* Left/Right Carousel Arrows (hidden by default) */}
                {property.images.length > 1 && (
                  <>
                    <IconButton
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        left: 8,
                        opacity: 0,
                        transform: 'translateY(-50%)',
                        backgroundColor: 'rgba(255,255,255,0.3)',
                        backdropFilter: 'blur(2px)',
                        '&:hover': {
                          opacity: 1,
                          backgroundColor: 'rgba(255,255,255,0.5)'
                        }
                      }}
                      onClick={(e) => handlePrevImage(property.id, e)}
                    >
                      <ChevronLeft fontSize="small" />
                    </IconButton>
                    <IconButton
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        right: 8,
                        opacity: 0,
                        transform: 'translateY(-50%)',
                        backgroundColor: 'rgba(255,255,255,0.3)',
                        backdropFilter: 'blur(2px)',
                        '&:hover': {
                          opacity: 1,
                          backgroundColor: 'rgba(255,255,255,0.5)'
                        }
                      }}
                      onClick={(e) => handleNextImage(property.id, e)}
                    >
                      <ChevronRight fontSize="small" />
                    </IconButton>
                  </>
                )}

                {/* Dot Indicators */}
                {property.images.length > 1 && (
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: 10,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      display: 'flex',
                      gap: 1
                    }}
                  >
                    {property.images.map((_, index) => (
                      <Box
                        key={index}
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentImageIndex(prev => ({
                            ...prev,
                            [property.id]: index
                          }));
                        }}
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: '50%',
                          backgroundColor: currentImageIndex[property.id] == index ? '#1976d2' : '#ccc',
                          cursor: 'pointer',
                          transition: 'background-color 0.3s'
                        }}
                      />
                    ))}
                  </Box>
                )}

                <Box sx={{ position: 'absolute', top: 6, right: 6, display: 'flex', gap: 1 }}>
                  <Tooltip title="Share">
                    <IconButton
                      size="small"
                      sx={{ bgcolor: 'white' }}
                      onClick={(e) => handleShare(e, property)}
                    >
                      <Share fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="More Options">
                    <IconButton
                      size="small"
                      sx={{ bgcolor: 'white' }}
                      onClick={(e) => handleMenuOpen(e, property.id)}
                    >
                      <MoreVert fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  // Add this to prevent click propagation
                  onClick={(e) => e.stopPropagation()}
                >
                  <MenuItem
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEdit();
                    }}
                  >
                    Edit
                  </MenuItem>
                  <MenuItem
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete();
                    }}
                  >
                    Delete
                  </MenuItem>
                </Menu>
              </Box>

              <CardContent sx={{
                px: 2, py: 0.2, pb: '7px !important',
                borderBottom: 'none', // Remove bottom border
                '&:last-child': {
                  paddingBottom: '7px !important',
                  borderBottom: 'none' // Remove border for last child
                }
              }}>
                {/* Title and Price row */}
                <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={0.5}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    noWrap
                    sx={{
                      flex: 1,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      pr: 1
                    }}
                  >
                    {property.title}-{property.property_name}
                  </Typography>
                  <Typography variant="body2" fontWeight="bold" color="primary" noWrap>
                    ₹{Number(String(property.price).replace(/[^0-9]/g, '')).toLocaleString('en-IN')}
                  </Typography>
                </Box>


                {/* Location and Date row */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    noWrap
                    sx={{
                      flex: 1,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      pr: 1
                    }}
                  >
                    {property.location}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" noWrap>
                    {new Date(property.date).toLocaleDateString('en-IN', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric'
                    })}
                  </Typography>
                </Box>


                <Box display="flex" alignItems="center" mt={0.2}>
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      if (property.lat && property.long) {
                        openGoogleMapsWithDirections(property.lat, property.long);
                      }
                    }}
                  >
                    <LocationOn fontSize="small" color="action" />
                  </IconButton>

                  <Typography variant="caption" color="text.primary" ml={0.5}>
                    Location
                  </Typography>
                  <Box sx={{ flexGrow: 1 }} />
                  <Button
                    size="small"
                    variant="outlined"
                    color="success"
                    startIcon={<Call />}
                    sx={{ textTransform: 'none', px: 1.2, py: 0.3, fontSize: '0.7rem' }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    Call
                  </Button>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    overflow: 'hidden',
                  }}
                >
                  {[
                    { label: 'Facing', value: property.facing },
                    { label: `Area `, value: property.area },
                    { label: 'Posted By', value: property.posted_by },
                  ].map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        flex: 1,
                        px: 1,
                        py: 0.2,
                        textAlign: 'center',
                        borderRight: index < 2 ? '1px solid #e0e0e0' : 'none',
                      }}
                    >
                      <Typography variant="caption" color="text.secondary" noWrap>
                        {item.label}
                      </Typography>
                      <Typography variant="body2" fontWeight="bold" noWrap>
                        {item.value}
                      </Typography>
                    </Box>
                  ))}
                </Box>
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '2px', // Consistent spacing
                  // height: 12,
                  // padding: "10px",
                  // mt: 1,
                  py: 1,
                  px: 1,
                  paddingLeft: 0,

                  // overflowX: 'auto', // Allows horizontal scrolling if needed (rare)
                }}>
                  {/* Wishlist Button */}
                  <Button
                    startIcon={<FavoriteBorder />}
                    variant="contained"
                    onClick={(e) => handleWishlistClick(property.id, e)}
                    sx={{
                      backgroundColor: '#F1C93B',
                      color: 'black',
                      fontSize: 'clamp(0.6rem, 2.5vw, 0.7rem)', // Responsive font
                      textTransform: 'none',
                      flex: '1 1 auto', // Flexible but equal width
                      minWidth: '100px', // Minimum width for small screens
                      whiteSpace: 'nowrap',
                      '&:hover': { backgroundColor: '#e3b92f' },
                      py: 1,
                      px: 1,
                    }}
                  >
                    Wishlist ({property.wishlistCount})
                  </Button>

                  {/* Matching Buyers Button */}
                  <Button
                    variant="contained"
                    onClick={(e) => handleMatchingBuyersClick(property.id, e)}
                    sx={{
                      backgroundColor: '#2ECC71',
                      color: 'white',
                      fontSize: 'clamp(0.6rem, 2.5vw, 0.7rem)',
                      textTransform: 'none',
                      flex: '1 1 auto',
                      minWidth: '100px',
                      whiteSpace: 'nowrap',
                      '&:hover': { backgroundColor: '#28b765' },
                      py: 1,
                      px: 1,
                    }}
                  >
                    Matching ({property.matchingBuyersCount || 0})
                  </Button>

                  {/* Delete Button */}
                  <Button
                    variant="contained"
                       onClick={(e) => {
    e.stopPropagation();
    const confirmDelete = window.confirm(`Are you sure you want to delete property ID ${property.id}?`);
    
    if (confirmDelete) {
      handleDeleteProperty(property.id);
    }
  }}
                    sx={{
                      backgroundColor: '#E74C3C',
                      color: 'white',
                      fontSize: 'clamp(0.6rem, 2.5vw, 0.7rem)',
                      textTransform: 'none',
                      flex: '1 1 auto',
                      minWidth: '100px',
                      whiteSpace: 'nowrap',
                      '&:hover': { backgroundColor: '#c0392b' },
                      py: 1,
                      px: 1,
                    }}
                  >
                    Delete
                  </Button>
                </Box>

                {/* Extension section */}
<Box
  sx={{
    // backgroundColor: '#f2f2f2',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    // boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    // maxWidth: { xs: 400, sm: 'none' },
    // width: '100%',
    // margin: { xs: '-3px -3px', sm: '0 auto' },
    // mt: 1,
    // px: 2,
    // py: 1,
    // gap: 1, 
      fontSize: 'clamp(0.6rem, 2.5vw, 0.7rem)',
                      textTransform: 'none',
                      flex: '1 1 auto',
                      minWidth: '100px',
                      whiteSpace: 'nowrap',
  }}
>
  {/* Extend Button */}
  <Box sx={{ display:'flex' ,gap:0.5}}>
  <Button
    variant="contained"
    disableElevation
    disabled={daysLeft > 7}
    onClick={handleExtensionClick}
    sx={{
      backgroundColor: daysLeft > 0 ? '#d3d3d3' : '#ff6b6b',
      color: 'black',
      textTransform: 'none',
      fontWeight: 'bold',
      fontSize: '0.6rem',
     
       p:1.3 ,
      '&:hover': {
        backgroundColor: daysLeft > 0 ? '#d3d3d3' : '#ff8787',
      },
      '&:disabled': {
        backgroundColor: '#d3d3d3',
        color: '#666666',
      },
    }}
  >
    Extend Your Post
  </Button>

  {/* View List Button */}
  <Button
    startIcon={<VisibilityIcon />}
    variant="contained"
    onClick={(e) => handleViewListClick(property.id, e)}
    sx={{
      backgroundColor: '#2196F3',
      color: 'white',
      fontSize: '0.59rem',
      textTransform: 'none',
      minWidth: '110px',
      p:1.1,
     
      whiteSpace: 'nowrap',
      '&:hover': { backgroundColor: '#1976D2' },
    }}
  >
    View List
  </Button>
  </Box>

  {/* Days Left */}
  <Typography
    sx={{
      fontWeight: 'bold',
      color: daysLeft === 0 ? 'red' : daysLeft <= 7 ? 'orange' : 'green',
      fontSize: '0.85rem',
      whiteSpace: 'nowrap',
    }}
  >
    {daysLeft === 0 ? (
      'Expired'
    ) : (
      <>
        Days left: <span style={{ fontWeight: 700 }}>{daysLeft}</span>
      </>
    )}
  </Typography>
</Box>

              </CardContent>
            </Card>

          ))
        ) : (
          // NEW: Only show this when showNoResults is true (after loading complete and no properties)
          showNoResults && (
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '200px',
              px: 2
            }}>
              <Typography>
                {searchQuery ? 'No properties found matching your search.' : 'No properties found.'}
              </Typography>
            </Box>
          )
        )}
      </Box>

      <BottomNavbar />
    </Box>
  );
};

export default PropertyCard;
